import { render, staticRenderFns } from "./statuses-statistics-details.vue?vue&type=template&id=dc852224&scoped=true&"
import script from "./statuses-statistics-details.vue?vue&type=script&lang=js&"
export * from "./statuses-statistics-details.vue?vue&type=script&lang=js&"
import style0 from "./statuses-statistics-details.vue?vue&type=style&index=0&id=dc852224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc852224",
  null
  
)

export default component.exports